import PropTypes from 'prop-types';

const propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    apirCode: PropTypes.string,
    stockCode: PropTypes.string,
    stockExchange: PropTypes.string,
    isin: PropTypes.string,
    fundType: PropTypes.string,
    fundAssetClass: PropTypes.string,
    company: PropTypes.shape({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      logoColor: PropTypes.string,
      logoPictureUrl: PropTypes.string,
      name: PropTypes.string.isRequired,
      summary: PropTypes.string,
    }).isRequired,
    activePartnership: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
    currency: PropTypes.string,
    disclaimer: PropTypes.string,
    inceptionDate: PropTypes.string,
    investUrl: PropTypes.string,
    fundPageUrl: PropTypes.string,
    investmentHorizon: PropTypes.string,
    members: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      role: PropTypes.string,
      position: PropTypes.string,
    })).isRequired,
    minimumInvestment: PropTypes.number,
    name: PropTypes.string.isRequired,
    objective: PropTypes.string,
    performance: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
      updatedAt: PropTypes.string,
    })).isRequired,
    pdsFileUrl: PropTypes.string,
    monthlyUpdateFileUrl: PropTypes.string,
    tmdFileUrl: PropTypes.string,
    published: PropTypes.bool.isRequired,
    isFollowedByCurrentUser: PropTypes.bool.isRequired,
    updatedAt: PropTypes.string.isRequired,
    qandasUpdatedAt: PropTypes.string,
    managementFee: PropTypes.string,
    isPerformanceFeeChargedUnknown: PropTypes.bool,
    isPerformanceFeeChargedYes: PropTypes.bool,
    isPerformanceFeeChargedNo: PropTypes.bool,
    performanceFeePds: PropTypes.string,
    performanceFee: PropTypes.string,
    performanceFeeMethodology: PropTypes.string,
    totalCostRatio: PropTypes.string,
    financialYearEndFeesDate: PropTypes.string,
    buySpread: PropTypes.string,
    sellSpread: PropTypes.string,
    pdsFeesDate: PropTypes.string,
    latestProspectusDate: PropTypes.string,
    dayEndEntryPrice: PropTypes.string,
    dayEndExitPrice: PropTypes.string,
    dayEndNavPrice: PropTypes.string,
    dayEndMarketPrice: PropTypes.string,
    dayEndMarketPriceDate: PropTypes.string,
    dayEndPricingUpdateDate: PropTypes.string,
    fundInvestorVehicleType: PropTypes.string,
    isInTopRatedFundsSeries: PropTypes.bool,
    isInIncomeSeries: PropTypes.bool,
  }).isRequired,
  livewireLogo: PropTypes.string.isRequired,
  topRatedFundSeriesDesktopBackground: PropTypes.string.isRequired,
  topRatedFundSeriesMobileBackground: PropTypes.string.isRequired,
  topRatedFundSeriesLogo: PropTypes.string.isRequired,
  incomeSeriesBackground: PropTypes.string.isRequired,
  incomeSeriesLogo: PropTypes.string.isRequired,
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
  showInModal: PropTypes.bool.isRequired,
  viewAllWiresLink: PropTypes.string.isRequired,
};

export default propTypes;
